import type {
  DagDashboardListParams,
  DagDashboardResponse,
  DagListRunStatus,
  DagVersionSnapshot,
  DagVersionStatusItem,
} from '@/entities/dag';

export const DAG_RUN_STATUS_FILTER_VALUES = {
  ALL: 'all',
  DRAFT: 'draft',
  FAILURE: 'failure',
  PENDING: 'pending',
  RUNNING: 'running',
  SUCCESS: 'success',
} as const;

export const DAG_FAVORITE_FILTER_VALUES = {
  ALL: 'all',
  FAVORITES: 'favorites',
  NON_FAVORITES: 'non-favorites',
} as const;

export const DAG_MATURITY_FILTER_VALUES = {
  ALL: 'all',
  BRONZE: 'bronze',
  SILVER: 'silver',
  GOLD: 'gold',
} as const;

export type DagRunStatusFilterValue =
  | (typeof DAG_RUN_STATUS_FILTER_VALUES)[keyof typeof DAG_RUN_STATUS_FILTER_VALUES]
  | DagListRunStatus;
export type DagFavoriteFilterValue = (typeof DAG_FAVORITE_FILTER_VALUES)[keyof typeof DAG_FAVORITE_FILTER_VALUES];
export type DagMaturityFilterValue = (typeof DAG_MATURITY_FILTER_VALUES)[keyof typeof DAG_MATURITY_FILTER_VALUES];

export type DagListFilterState = {
  searchQuery: string;
  selectedRunStatus: DagRunStatusFilterValue[];
  selectedFavorite: DagFavoriteFilterValue[];
  selectedMaturity: DagMaturityFilterValue[];
  selectedTags: string[];
};

export type DagTableRow = DagDashboardResponse & {
  selectedVersion?: number | 'initialized';
  selectedVersionItem?: DagVersionStatusItem | null;
  displaySchedule?: string | null;
  displayNextRun?: string | null;
  displayStatus?: DagListRunStatus;
  displayLastRun?: string | null;
  versionSnapshots: DagVersionSnapshot[];
};

export type DagDashboardSortField = NonNullable<DagDashboardListParams['sortBy']>;
export type DagDashboardSortOrder = NonNullable<DagDashboardListParams['sortOrder']>;
